import { createFileRoute } from '@tanstack/react-router';

import { Landing } from '#features/landing/components/Landing';
import { landingRouteLoader } from '#features/landing/utils/landingRoute';

const gameSlug = 'apex-legends';

export const Route = createFileRoute('/{-$locale}/_layout/preview/match-replay')({
  staticData: { rendersOwnFooter: true },
  loader: ({ context }) => landingRouteLoader(context.queryClient, gameSlug),
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
  component: () => <Landing gameSlug={gameSlug} painVariant="replay" />,
});
